var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCre(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.642 6.022c-1.684.694-4.83.818-6.417.843H13.993A5.288 5.288 0 0 0 9.384 9.54l-1.189 2.008c-.099.198.05.42.273.371a6.35 6.35 0 0 1 1.536-.174h15.708a3.736 3.736 0 0 0 3.22-1.858l2.033-3.494c.123-.223-.1-.47-.323-.372zm-7.606 14.495c-.47.123-.941.222-1.462.222h-16.5c-.893 0-1.71.47-2.156 1.238l-1.883 3.246c-.1.173.025.396.223.396l16.402-.05a5.172 5.172 0 0 0 4.46-2.576l1.213-2.106a.262.262 0 0 0-.297-.372zm3.741-6.913h.05c.198 0 .322.223.223.396l-1.635 2.825a3.736 3.736 0 0 1-3.221 1.858H6.486c-.52 0-1.04.05-1.536.174H4.9c-.198 0-.322-.224-.223-.397l1.982-3.444a2.486 2.486 0 0 1 2.155-1.239H25.24c.521 0 1.042-.05 1.537-.173z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCre);
export default __webpack_public_path__ + "static/media/CRE.811e021d4bfbab67216ccd7d7a301ae0.svg";
export { ForwardRef as ReactComponent };